import boardApi from '@/api/boardAPI'

//TODO: Remove unsetXXX methods
export const boardStore = {
    namespaced: true,

    state: {
        boards: {},
        boardsItems: {},
        lastCreatedBoard: null,
        lastUpdatedBoard: null,
        lastCreatedBoardItem: null,
        lastUpdatedBoardItem: null,
        lastOperationSucceed: null,
    },
    mutations: {
      setBoard(state, board) {
          if (board) {
            state.boards[board.id] = board
          }
        },
        setBoardItems(state, data) {
            const { items, id } = data
            state.boardsItems[id] = items
        },
        addBoardItem(state, item) {
          if (!state.boardsItems[item.board_id]) {
            state.boardsItems[item.board_id] = [item]
          } else {
              state.boardsItems[item.board_id].push(item)
          }
        },
        // Realtime events can name a board whose items this tab never loaded (or hasn't yet):
        // nothing to update then.
        replaceBoardItem(state, item) {
            if (!state.boardsItems[item.board_id]) return
            const index = state.boardsItems[item.board_id].findIndex(boardItem => boardItem.id === item.id)
            if (index !== -1) {
                state.boardsItems[item.board_id][index] = item
            }
        },
        addOrReplaceBoardItem(state, item) {
            if (!state.boardsItems[item.board_id]) {
                state.boardsItems[item.board_id] = [item]
                return 0
            }
            const index = state.boardsItems[item.board_id].findIndex(boardItem => boardItem.id === item.id)
            if (index !== -1) {
                state.boardsItems[item.board_id][index] = item
            } else {
                state.boardsItems[item.board_id].push(item)
            }
        },
        removeBoardItem(state, item) {
            if (!state.boardsItems[item.board_id]) return
            const index = state.boardsItems[item.board_id].findIndex(boardItem => boardItem.id === item.id)
            if (index !== -1) {
                state.boardsItems[item.board_id].splice(index, 1)
            }
        },
        setLastCreatedBoard(state, board) {
            state.lastCreatedBoard = board
        },
        unsetLastCreatedBoard(state) {
            state.lastCreatedBoard = null
        },
        setLastUpdatedBoard(state, board) {
            state.lastUpdatedBoard = board
        },
        unsetLastUpdatedBoard(state) {
            state.lastUpdatedBoard = null
        },
        setLastCreatedBoardItem(state, boardItem) {
            state.lastCreatedBoardItem = boardItem
        },
        unsetLastCreatedBoardItem(state) {
            state.lastCreatedBoardItem = null
        },
        setLastUpdatedBoardItem(state, boardItem) {
            state.lastUpdatedBoardItem = boardItem
        },
        unsetLastUpdatedBoardItem(state) {
            state.lastUpdatedBoardItem = null
        },
        setLastOperationSucceed(state, succeed) {
            state.lastOperationSucceed = succeed
        },
        unsetLastOperationSucceed(state) {
            state.lastOperationSucceed = null
        }
    },
    actions: {
        async loadBoard({commit}, id) {
            commit('setBoard', null)
            commit('unsetLastOperationSucceed')

            try {
                const board = (await boardApi.getBoard(id)).data
                commit('setBoard', board)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('setLastOperationSucceed', false)
            }
        },
        async loadBoardItems({commit}, id) {
            commit('setBoardItems', {items: [], id})
            commit('unsetLastOperationSucceed')

            try {
              const items = (await boardApi.getBoardItems(id)).data
              commit('setBoardItems', { items, id })
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('setLastOperationSucceed', false)
            }
        },
        async createBoard({commit}, data) {
            commit('unsetLastCreatedBoard')
            commit('unsetLastOperationSucceed')

            try {
                const board = (await boardApi.createBoard(data)).data
                commit('setLastCreatedBoard', board)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('unsetLastOperationSucceed', false)
            }
        },
        async updateBoard({commit}, data) {
            commit('unsetLastUpdatedBoard')
            commit('unsetLastOperationSucceed')

            if (typeof data.id === 'undefined') {
                commit('unsetLastOperationSucceed', false)
                return
            }

            try {
                const board = (await boardApi.updateBoard(data.id, data)).data
                commit('setLastUpdatedBoard', board)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('unsetLastOperationSucceed', false)
            }
        },
        async createBoardItem({commit}, data) {
            commit('unsetLastCreatedBoardItem')
            commit('unsetLastOperationSucceed')

            if (typeof data.board_id === 'undefined') {
                commit('unsetLastOperationSucceed', false)
                return
            }

            try {
                const item = (await boardApi.createBoardItem(data.board_id, data)).data
                commit('setLastCreatedBoardItem', item)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('unsetLastOperationSucceed', false)
            }
        },
        async updateBoardItem({commit}, data) {
            commit('unsetLastUpdatedBoardItem')
            commit('unsetLastOperationSucceed')

            if (typeof data.board_id === 'undefined' || typeof data.id === 'undefined') {
                commit('unsetLastOperationSucceed', false)
                return
            }

            try {
                const item = (await boardApi.updateBoardItem(data.board_id, data.id, data)).data
                commit('setLastUpdatedBoardItem', item)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('unsetLastOperationSucceed', false)
            }
        },
        async removeBoardItem({commit}, data) {
            commit('unsetLastOperationSucceed')

            if (typeof data.board_id === 'undefined' || typeof data.id === 'undefined') {
                commit('unsetLastOperationSucceed', false)
                return
            }

            try {
                await boardApi.removeBoardItem(data.board_id, data.id)
                commit('setLastOperationSucceed', true)
            } catch (error) {
                commit('unsetLastOperationSucceed', false)
            }
        },
    }
}
